import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  InvitacionCrear,
  CloudFunctionResponse,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

const invitacionCrear = async (
  data: InvitacionCrear
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "invitacionCrear",
    params: data
  });
  return result.data;
};

export { invitacionCrear };
